<template>
  <div
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    data-sb-regression="sb-filter-bar"
    class="sb-filter-bar"
  >
    <div class="sb-filter-bar__filters">
      <!--
        @slot slot to show the filter elements
      -->
      <slot name="filters" />
    </div>
    <div
      class="sb-filter-bar__search"
      :class="{
        'sb-filter-bar__search--full': filtersNotProvided
      }"
    >
      <!--
        @slot slot to show search bar
      -->
      <slot name="search" />
      <div class="sb-filter-bar__helper-text">
        <ExpandTransition>
          <SbText v-if="showHelperText">
            {{ helperText }}
          </SbText>
        </ExpandTransition>
      </div>
    </div>
    <div class="sb-filter-bar__chips">
      <!--
        @slot slot to show selected filter chips
      -->
      <slot name="chips" />
    </div>
  </div>
  <SbFilterBarNext
    v-else
    v-model:appliedFilters="appliedFilters"
    v-model:appliedColumns="appliedColumns"
    :placeholder="placeholder"
    :column-definitions="columnDefinitions"
    :filters="filters"
    @removed-filter="$emit('removed-filter', $event)"
    @search="$emit('search', $event)"
  >
    <template #search>
      <slot name="search" />
    </template>
    <template
      v-if="$slots.filters"
      #filters
    >
      <slot name="filters" />
    </template>
    <template
      v-if="$slots.chips"
      #chips
    >
      <slot name="chips" />
    </template>
    <template #options>
      <slot name="options" />
    </template>
  </SbFilterBarNext>
</template>

<script>
import { defineModel, defineEmits } from 'vue';
import SbText from '@src/components/Text/SbText.vue';
import ExpandTransition from '@src/components/Transitions/Expand.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbFilterBarNext from '@src/components/Filter/next/SbFilterBarNext.vue';

defineModel('appliedFilters');
defineModel('appliedColumns');
defineEmits(['removed-filter', 'search']);

/**
 * This is a wrapper component to be used with the table template.
 * It composes slots for the filter dropdown, search filter, and filter chips.
 */
export default {
  name: 'SbFilterBar',
  components: {
    SbText,
    ExpandTransition,
    SbFilterBarNext,
  },
  mixins: [versionedComponentsMixin],
  provide() {
    return {
      filterSearch: this.filterSearch,
    };
  },
  props: {
    placeholder: {
      type: String,
    },
    columnDefinitions: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    filterSearch: {
      showHelperText: false,
      helperText: '',
    },
  }),
  computed: {
    filtersNotProvided() {
      return this.$slots.filters ? this.$slots.filters() === undefined : true;
    },
    showHelperText() {
      return this.filterSearch.showHelperText;
    },
    helperText() {
      return this.filterSearch.helperText;
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/Filter/style/sb-filter-bar.scss';
</style>
